module.exports = __webpack_public_path__ + "static/media/电源管理模块.d1efe52c.png";